const DAY = 86400000;
function parse(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
  const date = new Date(`${value}T00:00:00Z`);
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value ? date : null;
}

export function shiftDatePeriod(start, end, direction) {
  const from = parse(start), to = parse(end);
  if (!from || !to || to < from || ![-1, 1].includes(direction)) return null;
  // Whole calendar months stay whole months, including February/leap years.
  if (from.getUTCDate() === 1 && from.getUTCMonth() === to.getUTCMonth() &&
      from.getUTCFullYear() === to.getUTCFullYear() &&
      new Date(to.getTime() + DAY).getUTCDate() === 1) {
    const month = from.getUTCMonth() + direction;
    return { start: new Date(Date.UTC(from.getUTCFullYear(), month, 1)).toISOString().slice(0, 10),
      end: new Date(Date.UTC(from.getUTCFullYear(), month + 1, 0)).toISOString().slice(0, 10) };
  }
  const offset = (Math.round((to - from) / DAY) + 1) * direction * DAY;
  return { start: new Date(from.getTime() + offset).toISOString().slice(0, 10),
    end: new Date(to.getTime() + offset).toISOString().slice(0, 10) };
}

export function shiftDateRange(range, direction) {
  const from = range?.from || new Date(), to = range?.to || from;
  const iso = d => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
  const next = shiftDatePeriod(iso(from), iso(to), direction);
  return next ? { from: new Date(`${next.start}T00:00:00`), to: new Date(`${next.end}T00:00:00`) } : range;
}
